import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUIStore } from '../../store/uiStore';
import { isDemoMode } from '../../api/demo/setup';
import { DemoTourOverlay } from './DemoTourOverlay';
import { demoTourSteps } from './storyboard';

const TOTAL_STEPS = demoTourSteps.length;

export function DemoTour() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    demoTourStep,
    demoTourVisible,
    startDemoTour,
    nextDemoTourStep,
    prevDemoTourStep,
    endDemoTour,
  } = useUIStore();

  const hasStarted = useRef(false);

  // Auto-start tour on first mount in demo mode
  useEffect(() => {
    if (isDemoMode() && !hasStarted.current) {
      hasStarted.current = true;
      startDemoTour();
    }
  }, [startDemoTour]);

  // Navigate when step changes
  const step = demoTourSteps[demoTourStep];
  useEffect(() => {
    if (!demoTourVisible || !step) return;
    const targetSearch = step.search ?? '';
    if (location.pathname !== step.route || location.search !== targetSearch) {
      navigate({
        pathname: step.route,
        search: targetSearch,
      });
    }
  }, [demoTourStep, demoTourVisible, step, location.pathname, location.search, navigate]);

  if (!demoTourVisible || !step) return null;

  const handleNext = () => {
    if (demoTourStep >= TOTAL_STEPS - 1) {
      endDemoTour();
      navigate('/create');
      return;
    }
    nextDemoTourStep();
  };

  const handlePrev = () => {
    if (demoTourStep > 0) {
      prevDemoTourStep();
    }
  };

  const handleSkip = () => {
    endDemoTour();
  };

  return (
    <DemoTourOverlay
      step={step}
      stepIndex={demoTourStep}
      totalSteps={TOTAL_STEPS}
      onNext={handleNext}
      onPrev={handlePrev}
      onSkip={handleSkip}
    />
  );
}
